import React, { useContext } from "react";
import { createPortal } from "react-dom";
import { ReactSVG } from "react-svg";
import { imgs } from "@gw/theming";
import { useEnvContext } from "@gw/env-context";
import { ModalsStackStyled, Overlay, Modal } from "./ModalsStackStyled";
import { default as ModalsContext } from "./ModalsContext";
var ModalsStack = function (props) {
    var imgsFolder = useEnvContext().imgsFolder;
    var _a = useContext(ModalsContext), modals = _a.modals, closeModal = _a.closeModal;
    return createPortal(React.createElement(ModalsStackStyled, null, modals.map(function (n, i) {
        return (React.createElement(Overlay, { key: "notification-" + i, position: i },
            React.createElement(Modal, { className: "modal-container" },
                React.createElement("div", { className: "title-bar" },
                    React.createElement("h3", null, n.title),
                    !n.preventClose && (React.createElement("div", { className: "close-container" },
                        React.createElement(ReactSVG, { className: "icon", src: imgsFolder + "/" + imgs.icons.close, onClick: function () { return closeModal(n.id); } })))),
                React.createElement("div", { className: "modal-content" }, n.content))));
    })), document.querySelector("#modals-stack"));
};
export default ModalsStack;
//# sourceMappingURL=ModalsStack.js.map